import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * События элемента
 * 
 * onCreateBoxClick(shop) - запрос на добавление магазина. * 
 * onCancelClick() - запрос отмены.
 */

class CreateBoxDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            code: "",
            dialog: undefined,
        }

    }

    isReady() {
        if (this.state.code === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Добавить коробку
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.code}
					label = "Код коробки"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({code: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreateBoxClick === "function") {
                            this.props.onCreateBoxClick({
                                code: this.state.code,
                            })
                        }
                    }}
                >Добавить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default CreateBoxDialog